module.exports = __webpack_public_path__ + "static/media/Circo2025_16.dfe97fa6.webp";